import React, { Suspense, useEffect } from 'react';

import EverflowSDK from '@everflow/everflow-sdk';
import * as Sentry from '@sentry/react';
import { setConfiguration } from 'react-grid-system';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router-dom';

import packageInfo from '../package.json';

import { PortalProvider, TransitionArea } from './components';
import { ErrorElement } from './components/Error';
import { TickClipPath } from './components/FloorGameTicks/components';
import StyledThemeProvider from './components/Sections/Profile/StyledThemeProvider';
import config from './config';
import { AptosProvider, MediaQueryProvider, Web3Provider } from './providers';
// TODO: Circular dependencies are killing us. Moving this import
// above any of the previous imports will result in either a
// `lexical declaration` or `component annotation` error.
import { RoutesWrapper, YatRoutes } from './routes';

// eslint-disable-next-line no-console
console.log('Version:', packageInfo.version);

window['yatVersion'] = packageInfo.version;

const { everflowTrackingDomain } = config;
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);

function WrapperOutlet() {
    return (
        <>
            <Outlet />
            <RoutesWrapper />
        </>
    );
}

function SuspenseOutlet() {
    return (
        <>
            <Outlet />
            <Suspense fallback={<div />} />
        </>
    );
}

export function App() {
    // TODO: See if we can remove this `react-grid-system`.
    setConfiguration({
        breakpoints: [576, 768, 992, 1200, 1360],
        containerWidths: [0, 720, 960, 1140, 1300],
        gutterWidth: 0,
    });

    const router = sentryCreateBrowserRouter([
        {
            element: <SuspenseOutlet />,
            errorElement: <ErrorElement />,
            id: 'suspense-root',
            children: [
                {
                    element: <WrapperOutlet />,
                    errorElement: <ErrorElement />,
                    id: 'yat-routes',
                    children: [
                        {
                            path: '*',
                            element: <YatRoutes />,
                        },
                    ],
                },
            ],
        },
    ]);

    useEffect(() => {
        EverflowSDK.configure({
            tracking_domain: everflowTrackingDomain,
        });
    }, []);

    return (
        <Web3Provider>
            <AptosProvider>
                <StyledThemeProvider>
                    <MediaQueryProvider>
                        <PortalProvider>
                            <RouterProvider router={router} />
                            <TransitionArea />
                            <TickClipPath />
                        </PortalProvider>
                    </MediaQueryProvider>
                </StyledThemeProvider>
            </AptosProvider>
        </Web3Provider>
    );
}
